import { render, staticRenderFns } from "./KennelSimilarNamesDialog.vue?vue&type=template&id=35c37d56"
import script from "./KennelSimilarNamesDialog.vue?vue&type=script&lang=ts"
export * from "./KennelSimilarNamesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports